// ETKİSİ kadranı — lot tablosu (FİFO sırasıyla eski → yeni).
//
// TR fon satışı FİFO ile gerçekleşir (CLAUDE.md §5). "Lot seç" UI'ı yok;
// kullanıcı satılacak unit miktarını belirler, sistem FİFO ile hangi lotlardan
// tüketileceğini hesaplar. Tablonun altına FİFO notu eklenir.

import type { SignalLot } from "../data/mockSinyal";

interface Props {
  lots: SignalLot[];
}

function formatUnits(n: number): string {
  return new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(n);
}

function formatCost(n: number): string {
  return new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  }).format(n);
}

function formatTl(n: number, signed = true): string {
  const sign = n >= 0 ? "+" : "−";
  const abs = Math.abs(n).toLocaleString("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return signed ? `${sign}${abs} TL` : `${abs} TL`;
}

function formatDate(iso: string): string {
  // ISO → DD MMM (Türkçe kısa). Boş/parse hatasında ham döner.
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "short",
  });
}

export default function LotTablosu({ lots }: Props) {
  return (
    <div>
      <table
        className="w-full text-[12px]"
        aria-label="Lot tablosu (FİFO sırası)"
      >
        <thead>
          <tr className="text-ink-400 text-[10px] uppercase tracking-wider">
            <th className="text-left font-medium py-1">Lot</th>
            <th className="text-left font-medium py-1">Tarih</th>
            <th className="text-right font-medium py-1">Adet</th>
            <th className="text-right font-medium py-1">Maliyet</th>
            <th className="text-right font-medium py-1">PnL</th>
            <th className="text-right font-medium py-1">Vergi</th>
          </tr>
        </thead>
        <tbody className="fon-dili">
          {lots.map((lot, idx) => {
            const isFirst = idx === 0;
            return (
              <tr
                key={lot.id}
                className={`border-t border-ink-700/60 ${
                  isFirst ? "bg-accent-500/[0.04]" : ""
                }`}
              >
                <td
                  className={`py-1.5 ${
                    isFirst ? "text-accent-300" : "text-ink-200"
                  }`}
                >
                  #{idx + 1}
                </td>
                <td className="py-1.5 text-ink-300">
                  {formatDate(lot.purchase_date)}
                </td>
                <td className="py-1.5 text-right text-ink-200">
                  {formatUnits(lot.units)}
                </td>
                <td className="py-1.5 text-right text-ink-300">
                  {formatCost(lot.cost_per_unit)}
                </td>
                <td
                  className={`py-1.5 text-right ${
                    lot.gross_pnl_tl >= 0 ? "text-gain-400" : "text-loss-400"
                  }`}
                >
                  {formatTl(lot.gross_pnl_tl)}
                </td>
                <td className="py-1.5 text-right text-ink-300">
                  {formatTl(-Math.abs(lot.tax_tl))}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <p className="text-[10px] text-ink-400 mt-2 leading-snug">
        FİFO sırası gereği satış Lot #1'den başlar.
      </p>
    </div>
  );
}
